import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function CategoryNav() {
  const location = useLocation();

  return (
    <section className="w-full px-4 md:px-6 -mt-8 relative z-10">
      <div className="max-w-7xl mx-auto">
        <div className="bg-background-50 rounded-xl p-4 md:p-6 border border-background-200/70">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-grid-line text-primary-500 text-lg"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap">剧集分类</h3>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2">
            {categories.map((cat) => {
              const isActive =
                (cat.slug === 'all' && location.pathname === '/') ||
                location.pathname === `/category/${cat.slug}`;
              return (
                <Link
                  key={cat.slug}
                  to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                  className={`px-4 py-3 rounded-lg text-center text-sm font-medium transition-all whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-500 text-background-50 shadow-sm'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200/70 hover:text-foreground-950'
                  }`}
                >
                  {cat.name}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}